import { TemplatePage } from './types';

const foodPage: TemplatePage = {
  header: {
    color: '#B5D6DB',
    icon: 'images/video-templates/food-restaurants.jpg',
    title: 'Food Video Templates Collection',
    title_meta: '100+ Free and Customizable Food Video Templates',
    description_meta:
      'Create mouth-watering gastronomic videos with Wave.video’s 100+ free food video templates.',
    description:
      'Create mouth-watering gastronomic videos with these 100+ high-quality food video templates. Promote your cafe ' +
      'or restaurant, attract more readers to your food blog, or get more views on your cooking channel... as easy as pie!'
  },
  footer: {
    category: 'Food',
    description:
      'Wave.video’s large collection of professionally designed food video templates makes it hassle-free to create ' +
      'appetizing videos in a matter of minutes. All the templates are free to customize to suit your brand and goals.'
  },
  content: [
    {
      type: 'templates',
      title: 'food and restaurant',
      search: { category: '/Industries/Restaurants & Food' }
    },
    {
      type: 'stocks',
      title: 'food and restaurant',
      search: { name: 'food' }
    },
    { type: 'calendar' }
  ]
} as TemplatePage;

export default foodPage;
